import { EventEmitter, Injectable } from '@angular/core';
import { AtlasLanguageService, Language } from '@vendasta/atlas/core';
import { Observable, of } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { AtlasLanguageLoader } from '../language.loader';

@Injectable({providedIn: 'root'})
export class AtlasTranslateService {
  private currentTranslations$: Observable<JSON>;
  private currentTranslationsData: JSON;
  public onTranslationChange: EventEmitter<null> = new EventEmitter<null>();

  constructor(private languageService: AtlasLanguageService, private loader: AtlasLanguageLoader) {
    this.currentTranslations$ = this.languageService.language$.pipe(
      switchMap((language: Language) => this.loader.getTranslation(language)),
      shareReplay(1),
    );

    this.currentTranslations$.subscribe((data: JSON) => {
      this.currentTranslationsData = data;
      this.onTranslationChange.emit();
    });
  }

  stream(key: string, defaultText: string): Observable<string> {
    if (!key) {
      return of(defaultText);
    }
    return this.currentTranslations$.pipe(
      map((data: any) => {
        let translation = this.getTranslation(key, data);
        if (translation === key && defaultText !== '') {
          translation = defaultText;
        }
        return translation;
      })
    );
  }

  instant(key: string, defaultText: string): string {
    if (!this.currentTranslationsData) {
      return defaultText || key;
    }
    let translation = this.getTranslation(key, this.currentTranslationsData);
    if (translation === key) {
      translation = defaultText;
    }
    return translation;
  }

  private getTranslation(key: string, data: JSON): string {
    if (!key) {
      return '';
    }
    const keyParts = key.split('.');
    for (let i = 0; i < keyParts.length; i++) {
      const part = keyParts[i];
      if (data.hasOwnProperty(part)) {
        if (i + 1 === keyParts.length) {
          return data[part];
        } else {
          data = data[part];
        }
      } else {
        break;
      }
    }
    return key;
  }
}
